import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
export const CHECKOUT_URL = 'https://ready-tennis.impultienda.ar/checkout';
type CtaButtonProps = {
  label?: string;
  href?: string;
  className?: string;
};
export function CtaButton({
  label = 'Get the Tennis Ready Pack',
  href = CHECKOUT_URL,
  className = ''
}: CtaButtonProps) {
  const isInternal = href.startsWith('#');
  return <a href={href} target={isInternal ? undefined : '_blank'} rel={isInternal ? undefined : 'noopener noreferrer'} className={`group inline-flex items-center justify-center gap-3 rounded-full bg-lime px-7 py-5 text-center font-display text-xs font-extrabold uppercase leading-none text-ink shadow-soft transition-all duration-200 hover:-translate-y-0.5 hover:bg-lime-dark hover:text-white focus:outline-none focus-visible:ring-4 focus-visible:ring-lime/50 sm:px-9 sm:py-7 sm:text-base ${className}`} style={{
    paddingTop: "25px",
    paddingBottom: "25px"
  }} data-id="element-41" data-mp="qkah56zaz5uf">
      <span className="-mr-[0.12em] tracking-[0.12em]" data-id="element-42" data-mp="15baxrza7e61n">{label}</span>
      <ArrowRightIcon className="h-4 w-4 shrink-0 transition-transform duration-200 group-hover:translate-x-1" aria-hidden="true" data-id="element-43" data-mp="35y7i8daaiuyg" />
    </a>;
}